import { render, staticRenderFns } from "./playlist-coffee-card.vue?vue&type=template&id=11708cc2&scoped=true&"
import script from "./playlist-coffee-card.vue?vue&type=script&lang=js&"
export * from "./playlist-coffee-card.vue?vue&type=script&lang=js&"
import style0 from "./playlist-coffee-card.vue?vue&type=style&index=0&id=11708cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11708cc2",
  null
  
)

export default component.exports